import { render, staticRenderFns } from "./WarnPassword.vue?vue&type=template&id=db22db0c&scoped=true"
import script from "./WarnPassword.vue?vue&type=script&lang=js"
export * from "./WarnPassword.vue?vue&type=script&lang=js"
import style0 from "./WarnPassword.vue?vue&type=style&index=0&id=db22db0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db22db0c",
  null
  
)

export default component.exports